import React, { useState } from "react";
import "./AccordionBullets.css";

interface Bullet {
  id: string;
  title: string;
  content: string;
}

interface AccordionBulletsGlosarioProps {
  bullets: Bullet[];
  title: string;
}

/**
 * Componente que muestra una lista de viñetas con un título (triángulo apuntando a la derecha).
 * Al hacer clic en el título, se expande para mostrar su contenido, girando el triángulo hacia abajo.
 */
export default function AccordionBulletsGlosario({ bullets, title }: AccordionBulletsGlosarioProps) {
  const [expandedId, setExpandedId] = useState<string | null>(null);

  const handleToggle = (id: string) => {
    setExpandedId((prevId) => (prevId === id ? null : id));
  };

  return (
    <ul className="accordionList">
      <button
        className="accordionHeaderRlGlosario"
        aria-expanded={true}
      >
        <span className={`arrowIcon ${true ? "expanded" : ""}`} />
        <span className="accordionTitleRlGlosario">{title}</span>
      </button>
      {bullets.map((bullet) => {
        const isExpanded = true;
        //const isExpanded = true;
        return (
          <li key={bullet.id} className="accordionItemGlosario">

            <span className="accordionBulletGlosario">{bullet.title}:</span>
            <span className="accordionContentGlosario">{bullet.content}</span>


          </li>
        );
      })}
    </ul>
  );
}